@if (state && state.indices && state.indices[0]; as index) {
  @for (index of state?.indices; track index) {
    <div class="hits-other">
      <div class="title">
        <h4>
          {{ 'register.other' | translate }}
        </h4>
        <div class="hits stretch">{{ index.results.nbHits >= 100 ? '99+' : index.results.nbHits }}</div>
      </div>
      <div class="results-container">
        @for (hit of index.hits; track hit; let i = $index) {
          @if (hit | asPageHit | transformPageHit; as page) {
            <app-search-result
              [otherResult]="page"
              (resultClicked)="resultClicked.emit()"
            ></app-search-result>
          }
        }
      </div>
    </div>
  }
} @else {
  <app-page-spinner></app-page-spinner>
}
